import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { RichTextInput } from "@circle-react-uikit/RichTextInput";

const generateTempId = () =>
  // eslint-disable-next-line sonarjs/pseudo-random -- Disabled for plugin version update. Fix when possible
  `trix-editor-${Math.floor(Math.random() * 1000000)}`;

interface PostPurchaseBodyTextAreaProps {
  isDisabled: boolean;
}

export const PostPurchaseBodyTextArea = ({
  isDisabled,
}: PostPurchaseBodyTextAreaProps) => {
  const [forceRerender, setForceRerender] = useState(generateTempId());
  const {
    formState: { isSubmitSuccessful },
  } = useFormContext();

  useEffect(() => {
    setForceRerender(generateTempId());
  }, [isSubmitSuccessful]);

  return (
    <div
      key={`${forceRerender}`}
      className={classNames("trix-v2", {
        "pointer-events-none cursor-not-allowed": isDisabled,
      })}
    >
      <label>{t("settings.paywalls.modal.tabs.post_purchase.body")}</label>
      <RichTextInput
        id="post_purchase_email_message_input"
        name="post_purchase_email_message"
        is_private_space={false}
        preventAccidentalLeave={false}
        type="textarea"
        featureFlags={{
          embeds: false,
          videoUpload: false,
          fileUploadLink: false,
        }}
      />
    </div>
  );
};
